import { api } from '../lib/api';
import type { Banner, ApiResponse } from '../types';

class BannerService {
  /** Busca banners ativos por tipo (normal, fullwidth, login) */
  async getBannersByType(type: string): Promise<Banner[]> {
    try {
      const response = await api.get<ApiResponse<Banner[]>>(`/banners/type/${type}`);
      if (Array.isArray(response)) return response;
      return response.data || [];
    } catch {
      // Fallback: busca todos e filtra por tipo
      const all = await this.getActiveBanners();
      return all.filter((b: Banner) => type === 'normal' ? (b.type === 'normal' || !b.type) : b.type === type);
    }
  }

  /** Busca todos os banners ativos (endpoint público) */
  async getActiveBanners(): Promise<Banner[]> {
    try {
      const response = await api.get<ApiResponse<Banner[]>>('/public/banners');
      if (Array.isArray(response)) return response;
      return response.data || [];
    } catch {
      try {
        const response = await api.get<ApiResponse<Banner[]>>('/banners');
        const banners = Array.isArray(response) ? response : (response.data || []);
        return banners.filter((b: Banner) => b.is_active && b.status === 'approved');
      } catch {
        console.error('Nenhuma rota de banners disponível');
        return [];
      }
    }
  }

  async trackClick(bannerId: number): Promise<void> {
    await api.post(`/banners/${bannerId}/click`);
  }

  async trackImpression(bannerId: number): Promise<void> {
    await api.post(`/banners/${bannerId}/impression`);
  }
}

export const bannerService = new BannerService();
